const vi = {
  nav: {
    home: "Trang chủ",
    about: "Về chúng tôi",
    destinations: "Điểm đến",
    tours: "Tour & Gói du lịch",
    gallery: "Thư viện",
    testimonials: "Đánh giá",
    blog: "Blog",
    contact: "Liên hệ",
    experiences: "Trải nghiệm",
    vip: "VIP Business",
    vipFull: "Du lịch VIP Doanh nhân",
    worldcup: "World Cup 2030",
    jewishHeritage: "Du lịch Kosher",
    menu: "Menu",
    chatWhatsApp: "Chat trên WhatsApp"
  },
  hero: {
    welcome: "Chào mừng đến Maroc.",
    welcomeHome: "Chào mừng bạn về nhà.",
    subtitle: "Tour riêng sang trọng, trải nghiệm đích thực,",
    subtitleLine2: "và dịch vụ cá nhân hóa toàn diện khắp Maroc —",
    subtitleGold: "được đích thân CEO xử lý.",
    whatsappBtn: "Chat với Ilan (CEO) ngay trên WhatsApp",
    badgeFast: "Phản hồi nhanh",
    badgePersonal: "Dịch vụ cá nhân",
    badge247: "Hỗ trợ 24/7",
    limitedAvail: "Số lượng có hạn",
    personalizedOnly: "Chỉ thiết kế riêng"
  },
  strip: {
    privateTours: "Tour Riêng",
    localExperts: "Chuyên Gia Địa Phương",
    bestHotels: "Khách Sạn Tốt Nhất",
    luxuryTransport: "Phương Tiện Sang Trọng",
    satisfaction: "100% Hài Lòng"
  },
  cta: {
    whatsapp: "Chat với Ilan (CEO) ngay trên WhatsApp",
    whatsappFloating: "Chat WhatsApp",
    whatsappInquiry: "Xin chào, tôi quan tâm đến trải nghiệm du lịch cao cấp tại Maroc."
  },
  home: {
    vipBannerTitle: "Trải Nghiệm Du Lịch Maroc VIP",
    vipBannerText: "Đặc quyền ưu tiên, tài xế riêng và chỗ ở sang trọng dành cho những du khách sành điệu.",
    vipBannerBtn: "Khám phá Dịch vụ VIP",
    wcBadge: "🇲🇦 Maroc World Cup 2030",
    wcTitle: "Maroc 2030",
    wcText: "Các gói du lịch World Cup độc quyền kết hợp bóng đá, văn hóa Maroc, dịch vụ VIP và trải nghiệm sang trọng.",
    wcBtn: "Xem Các Gói",
    galleryTitle: "Thư Viện",
    gallerySubtitle: "Hé lộ chuyến đi tương lai của bạn tới Maroc",
    exploreDestination: "Khám phá điểm đến",
    featuredToursTitle: "Tour & Gói Du Lịch Nổi Bật",
    featuredToursSubtitle: "Những trải nghiệm được tuyển chọn cẩn thận cho cuộc phiêu lưu hoàn hảo tại Maroc",
    viewAllTours: "Xem Tất Cả Các Tour",
    culinaryTitle: "Thức ăn của chúng tôi - Tốt nhất thế giới",
    culinarySubtitle: "Trải nghiệm tinh hoa ẩm thực Ma-rốc 🍲",
    culinaryBtn: "Khám Phá Trải Nghiệm Ẩm Thực",
    culinaryIntro: "Tại Morocco Loves You, ăn uống không chỉ là việc nạp năng lượng. Đó là một hành trình vào trung tâm văn hóa Ma-rốc. Chúng tôi mang đến những trải nghiệm ẩm thực đích thực, được tuyển chọn kỹ lưỡng — từ những bữa cơm gia đình truyền thống đến ẩm thực Ma-rốc cao cấp, tất cả đều được chuẩn bị bằng tình yêu và những nguyên liệu địa phương tươi ngon nhất.",
    videoTitle: "KHUYẾN NGHỊ",
    unityQuote: "Morocco Loves You chào đón tất cả các nền văn hóa, tất cả các tín ngưỡng và tất cả các dân tộc.",
    unityAlt: "Biểu ngữ Đoàn kết Morocco Loves You",
    testimonialsTitle: "Khách Hàng VIP Nói Gì",
    testimonialsSubtitle: "Những đánh giá thực tế từ du khách quốc tế",
    readMoreReviews: "Đọc Thêm Đánh Giá",
    viewAllTransport: "Xem tất cả phương tiện",
    transportTitle: "Dịch vụ vận chuyển & Tài xế VIP của chúng tôi",
    transportSubtitle: "Sang trọng, Thoải mái & An toàn trên khắp Ma-rốc 🌍",
    transportIntro: "Tại Morocco Loves You, vận chuyển không chỉ là di chuyển từ nơi này sang nơi khác. Đó là một phần của trải nghiệm. Chúng tôi cung cấp các phương tiện hiện đại, sạch sẽ, thoải mái và có máy lạnh hoàn toàn trên khắp Ma-rốc — với tài xế chuyên nghiệp, lòng hiếu khách nồng hậu và dịch vụ VIP ngay từ những giây phút đầu tiên."
  },
  tours: {
    pageTitle: "Tour & Gói Du Lịch",
    pageSubtitle: "Chọn từ các gói tour Maroc được thiết kế cẩn thận của chúng tôi",
    sectionTitle: "Các Gói Tour Của Chúng Tôi",
    sectionIntro: "Từ những chuyến phiêu lưu trên sa mạc đến các kỳ nghỉ ở bãi biển, chúng tôi có gói du lịch hoàn hảo cho mọi du khách",
    howToBook: "Cách Đặt Chỗ",
    step1Title: "Chọn Một Tour",
    step1Text: "Duyệt qua các gói của chúng tôi và chọn gói phù hợp nhất với bạn",
    step2Title: "Nhấp Vào Đặt Ngay",
    step2Text: 'Nhấp vào nút "Đặt Ngay" ở tour bạn chọn',
    step3Title: "Điền Chi Tiết",
    step3Text: "Cung cấp ngày du lịch và thông tin cá nhân của bạn",
    step4Title: "Xác Nhận",
    step4Text: "Nhận thông tin xác nhận và lịch trình qua email",
    customTitle: "Cần một gói du lịch tùy chỉnh?",
    customText: "Liên hệ với chúng tôi để thiết kế trải nghiệm tour Maroc của riêng bạn",
    customBtn: "Liên Hệ",
    days: "Ngày",
    highlights: "Điểm nổi bật:",
    bookNow: "Đặt Ngay",
    highlightsLabel: "ĐIỂM NỔI BẬT:",
    viewFullDetails: "Xem Chi Tiết Đầy Đủ",
    premiumMoroccoPackages: "Gói Du Lịch Morocco Cao Cấp",
    premiumMoroccoPackagesDesc: "Những trải nghiệm độc quyền, được tuyển chọn kỹ lưỡng cho các vị khách tinh tế.",
    pkg1: {
      title: "Kỳ Nghỉ Cuối Tuần Sang Trọng Châu Âu/Morocco",
      duration: "3 Đêm / 4 Ngày",
      price: "€790",
      hl1: "Bao gồm chuyến bay khứ hồi trực tiếp (London/Châu Âu)",
      hl2: "Khách sạn sang trọng 4-5 sao",
      hl3: "Hammam Morocco truyền thống",
      hl4: "Workshop nấu ăn và nghệ thuật",
      hl5: "Biểu diễn trực tiếp Morocco"
    },
    pkg2: {
      title: "Tour Khám Phá Morocco Sang Trọng",
      duration: "6 Đêm / 7 Ngày",
      price: "€1490",
      hl1: "Gói A",
      hl2: "Hành trình Atlas",
      hl3: "Marrakech - Essaouira - Merzouga - Ouarzazate - Marrakech",
      hl4: "Bất ngờ lớn ❤️",
      hl5: "Gói B"
    },
    pkg3: {
      title: "Trải Nghiệm Morocco Grand",
      duration: "10 Đêm / 11 Ngày",
      price: "€1990",
      hl1: "Dịch vụ mặt đất cao cấp trọn gói",
      hl2: "Casablanca, Marrakech và Fes",
      hl3: "Agadir và những bất ngờ ở sa mạc Sahara",
      hl4: "Tham quan Ouarzazate và Chefchaouen",
      hl5: "Âm nhạc và biểu diễn trực tiếp đặc biệt"
    },
    pkg4: {
      title: "TRẢI NGHIỆM MOROCCO SANG TRỌNG",
      duration: "16 Đêm / 17 Ngày",
      price: "Trọn gói",
      hl1: "Casablanca • Rabat • Fes • Tangier • Chefchaouen",
      hl2: "Ifrane • Sa mạc Sahara Merzouga",
      hl3: "Essaouira • Ourika và dãy Atlas • Marrakech",
      hl4: "2 đêm trại sa mạc sang trọng với tour lạc đà và xe jeep",
      hl5: "Bình minh và hoàng hôn kỳ diệu • Ngủ dưới bầu trời sao"
    }
  },
  destinations: {
    pageTitle: "Khám Phá Các Điểm Đến Maroc",
    pageSubtitle: "Khám phá những địa điểm tuyệt vời trên khắp đất nước Maroc xinh đẹp",
    sectionTitle: "Tất Cả Các Điểm Đến",
    sectionIntro: "Maroc là một quốc gia có cảnh quan đa dạng và di sản văn hóa phong phú. Khám phá các điểm đến được lựa chọn cẩn thận của chúng tôi:",
    exploreNow: "Khám Phá Ngay",
    ctaTitle: "Sẵn Sàng Lên Kế Hoạch Chuyến Đi?",
    ctaText: "Duyệt qua các tour du lịch để tìm kiếm trải nghiệm Maroc hoàn hảo của bạn",
    ctaBtn: "Xem Tour & Gói Du Lịch"
  },
  experiences: {
    pageTitle: "Tinh Hoa Ẩm Thực Maroc",
    pageSubtitle: "Khám phá ẩm thực của chúng tôi — tốt nhất thế giới",
    bookViaWhatsApp: "Đặt chỗ qua WhatsApp"
  },
  vip: {
    pageTitle: "VIP & Du Lịch Doanh Nhân",
    pageSubtitle: "Dịch vụ độc quyền cho các CEO, nhà đầu tư và những du khách sành điệu",
    introTitle: "Sự Hoàn Hảo Liền Mạch tại Maroc",
    introText: "MoroccoLovesYou cung cấp tiêu chuẩn dịch vụ vô song cho du khách đi công tác, phái đoàn và khách VIP. Chúng tôi hiểu rằng thời gian của bạn là quý giá.",
    ctaTitle: "Quyền Truy Cập Trực Tiếp Vào CEO",
    ctaText: "Đối với các yêu cầu khẩn cấp và đặc biệt, hãy nói chuyện trực tiếp với Người sáng lập & CEO của chúng tôi, Ilan Hatchuel.",
    ctaBtn: "Liên hệ Ilan Ngay",
    luxuryTransport: "Phương Tiện Sang Trọng",
    luxuryTransportDesc: "Dịch vụ đón tiễn sân bay VIP và tài xế song ngữ riêng 24/7 với các dòng xe sang trọng (Mercedes S-Class, V-Class).",
    premiumAccom: "Chỗ Ở Cao Cấp",
    premiumAccomDesc: "Đặt phòng độc quyền tại các khách sạn 5 sao, riad sang trọng hoặc biệt thự riêng biệt.",
    businessConcierge: "Dịch Vụ Trợ Lý Kinh Doanh",
    businessConciergeDesc: "Hỗ trợ cuộc họp, đặt bàn ăn tối riêng và lịch trình chuyên biệt cho các sự kiện công ty.",
    securityPrivacy: "An Ninh & Quyền Riêng Tư",
    securityPrivacyDesc: "Dịch vụ kín đáo, môi trường an toàn và bảo mật tuyệt đối cho những nhân vật cấp cao.",
    support247: "Hỗ Trợ 24/7",
    support247Desc: "Liên hệ trực tiếp với CEO và đội ngũ tận tâm sẵn sàng hỗ trợ bạn bất cứ lúc nào.",
    customItineraries: "Lịch Trình Tùy Chỉnh",
    customItinerariesDesc: "Kế hoạch du lịch được thiết kế riêng cân bằng hoàn hảo giữa công việc và trải nghiệm văn hóa Maroc."
  },
  worldcup: {
    pageTitle: "World Cup Maroc 2030",
    pageSubtitle: "Các gói VIP & Trải Nghiệm Độc Quyền cho Sự kiện Bóng đá Lớn Nhất",
    limitedBadge: "Số Lượng Có Hạn",
    introTitle: "Hành Trình Bóng Đá Đỉnh Cao",
    introText: "Vào năm 2030, Maroc sẽ đồng đăng cai FIFA World Cup. Chúng tôi tự hào cung cấp các gói du lịch sang trọng trọn gói, được thiết kế cho những người hâm mộ đòi hỏi sự thoải mái nhất.",
    packagesTitle: "Các Gói World Cup Cao Cấp",
    silverTitle: "Gói Bạc",
    silverSub: "Trải nghiệm Cần Thiết",
    goldTitle: "Gói Vàng",
    goldSub: "Trải nghiệm Sang Trọng",
    mostPopular: "Phổ Biến Nhất",
    diamondTitle: "Kim Cương VIP",
    diamondSub: "Trải nghiệm Đỉnh Cao",
    inquireWhatsApp: "Yêu cầu qua WhatsApp",
    ctaTitle: "Bảo Đảm Chỗ Của Bạn Trước Khi Tăng Giá",
    ctaText: "Do nhu cầu quốc tế rất cao, chúng tôi đặc biệt khuyên bạn nên đặt gói VIP sớm.",
    ctaBtn: "Liên Hệ Với Chúng Tôi Ngay",
    silverF1: "Lưu Trú Tại Riad Cao Cấp / Khách Sạn 4 Sao",
    silverF2: "Hậu Cần Ngày Thi Đấu Được Lên Kế Hoạch Trước",
    silverF3: "Tour Du Lịch Thành Phố Có Hướng Dẫn",
    silverF4: "Đường Dây Hỗ Trợ Chuyên Dụng 24/7",
    goldF1: "Lưu Trú Tại Khách Sạn 5 Sao / Biệt Thử Sang Trọng",
    goldF2: "Đưa Đón Sân Bay & Sân Vận Động Riêng",
    goldF3: "Chuyến Đi Cắm Trại Sa Mạc VIP (2 Ngày)",
    goldF4: "Trợ Lý Cá Nhân Song Ngữ",
    diamondF1: "Phòng Tổng Thống / Cung Điện Riêng",
    diamondF2: "Tài Xế & An Ninh Riêng 24/7",
    diamondF3: "Quyền Truy Cập Đặc Quyền Vào Các Sự Kiện VIP",
    diamondF4: "CEO Trực Tiếp Xử Lý & Dịch Vụ VVIP"
  },
  gallery: {
    pageTitle: "Thư Viện Hình Ảnh",
    pageSubtitle: "Những kỷ niệm trực quan về chuyến hành trình khó quên",
    picturesTitle: "Maroc Qua Từng Bức Ảnh",
    picturesIntro: "Khám phá bộ sưu tập những bức ảnh ngoạn mục của chúng tôi",
    videosTitle: "Maroc Chuyển Động",
    videosIntro: "Trải nghiệm Maroc qua các video được tuyển chọn"
  },
  testimonials: {
    pageTitle: "Đánh Giá Của Khách Hàng",
    pageSubtitle: "Đọc xem du khách của chúng tôi nói gì về trải nghiệm của họ",
    sectionTitle: "Những Du Khách Hạnh Phúc",
    sectionIntro: "Hàng ngàn khách hàng hài lòng đã trải nghiệm sự kỳ diệu của Maroc cùng chúng tôi",
    verifiedGuest: "Khách Đã Xác Minh",
    ratingsTitle: "Đánh Giá",
    avgRating: "Đánh Giá Trung Bình",
    verifiedReviews: "Đánh Giá Đã Xác Minh",
    fromReal: "Từ du khách thực",
    custSatisfaction: "Mức Độ Hài Lòng",
    wouldRecommend: "Sẽ giới thiệu",
    shareTitle: "Chia Sẻ Trải Nghiệm Của Bạn",
    shareText: "Bạn đã có một chuyến đi tuyệt vời cùng chúng tôi? Chúng tôi muốn nghe về nó!",
    shareBtn: "Kể Câu Chuyện Của Bạn"
  },
  blog: {
    pageTitle: "Blog Du Lịch",
    pageSubtitle: "Câu chuyện, mẹo và cẩm nang cho cuộc phiêu lưu của bạn",
    sectionTitle: "Bài Viết Mới Nhất",
    sectionIntro: "Đọc các bài viết mới nhất của chúng tôi về du lịch Maroc",
    readMore: "Đọc Thêm →",
    by: "Bởi",
    newsletterTitle: "Đăng Ký Nhận Bản Tin",
    newsletterText: "Nhận các mẹo du lịch mới nhất và ưu đãi độc quyền",
    newsletterPlaceholder: "Nhập email của bạn",
    subscribe: "Đăng Ký"
  },
  contact: {
    pageTitle: "Liên Hệ",
    pageSubtitle: "Hãy liên lạc với nhóm của chúng tôi để lập kế hoạch cho chuyến đi của bạn",
    getInTouch: "Liên Hệ Ngay",
    getInTouchText: "Chúng tôi luôn sẵn sàng trợ giúp và trả lời mọi câu hỏi của bạn.",
    address: "Địa Chỉ",
    phone: "Điện Thoại",
    email: "Email",
    businessHours: "Giờ Làm Việc",
    businessHoursText: "Thứ Hai - Thứ Sáu: 9:00 - 18:00\nThứ Bảy: 10:00 - 16:00\nChủ Nhật: Đóng Cửa",
    followUs: "Theo Dõi Chúng Tôi",
    formTitle: "Gửi Tin Nhắn",
    successMessage: "✓ Cảm ơn! Chúng tôi sẽ liên hệ lại sớm.",
    fullName: "Họ và Tên",
    emailAddress: "Địa Chỉ Email",
    phoneNumber: "Số Điện Thoại",
    subject: "Chủ Đề",
    selectSubject: "Chọn một chủ đề",
    tourInquiry: "Hỏi Về Tour",
    bookingQuestion: "Câu Hỏi Đặt Chỗ",
    customPackage: "Gói Tùy Chỉnh",
    feedback: "Phản Hồi",
    other: "Khác",
    message: "Tin Nhắn",
    sendMessage: "Gửi Tin Nhắn",
    mapTitle: "Tìm Chúng Tôi Trên Bản Đồ",
    faqTitle: "Câu Hỏi Thường Gặp",
    faq1Q: "Thời gian tốt nhất để thăm Maroc là khi nào?",
    faq1A: "Mùa xuân (tháng 4-5) và mùa thu (tháng 9-10) cung cấp thời tiết tốt nhất.",
    faq2Q: "Tôi có cần visa không?",
    faq2A: "Yêu cầu visa phụ thuộc vào quốc tịch của bạn. Nhiều nước được miễn visa 90 ngày.",
    faq3Q: "Loại tiền tệ nào được sử dụng?",
    faq3A: "Đồng Dirham Maroc (MAD) là tiền tệ chính thức.",
    faq4Q: "Ngôn ngữ nào được sử dụng?",
    faq4A: "Tiếng Ả Rập và Berber là ngôn ngữ chính thức. Tiếng Pháp rất phổ biến.",
    faq5Q: "Maroc có an toàn cho du khách không?",
    faq5A: "Có, Maroc nhìn chung rất an toàn. Hướng dẫn viên của chúng tôi sẽ đảm bảo cho bạn.",
    faq6Q: "Tôi có thể tùy chỉnh tour không?",
    faq6A: "Chắc chắn rồi! Chúng tôi cung cấp các gói hoàn toàn tùy chỉnh."
  },
  about: {
    pageTitle: "Về MoroccoLovesYou",
    pageSubtitle: "Đối tác đáng tin cậy của bạn trong việc khám phá Maroc",
    storyTitle: "Câu Chuyện Của Chúng Tôi",
    storyP1: "MoroccoLovesYou được thành lập với sứ mệnh đơn giản: giúp du khách trải nghiệm vẻ đẹp và văn hóa đích thực.",
    storyP2: "Người sáng lập của chúng tôi đã phải lòng Maroc và muốn chia sẻ niềm đam mê này với thế giới.",
    missionTitle: "🎯 Sứ Mệnh Của Chúng Tôi",
    missionText: "Cung cấp những trải nghiệm du lịch đặc biệt thể hiện di sản văn hóa phong phú của Maroc.",
    visionTitle: "🌟 Tầm Nhìn Của Chúng Tôi",
    visionText: "Trở thành công ty du lịch hàng đầu tại Maroc được biết đến với tính xác thực và độ tin cậy.",
    whyTitle: "Tại Sao Chọn MoroccoLovesYou?",
    expertTitle: "Kiến Thức Chuyên Môn",
    expertText: "Đội ngũ của chúng tôi có kiến thức sâu rộng về Maroc.",
    localTitle: "Kết Nối Địa Phương",
    localText: "Chúng tôi làm việc với những hướng dẫn viên bản địa đích thực.",
    valueTitle: "Giá Trị Tốt Nhất",
    valueText: "Giá cả cạnh tranh mà không ảnh hưởng đến chất lượng.",
    safetyTitle: "An Toàn & Hỗ Trợ",
    safetyText: "Hỗ trợ 24/7 và bao gồm bảo hiểm du lịch toàn diện.",
    sustainTitle: "Du Lịch Bền Vững",
    sustainText: "Chúng tôi hỗ trợ cộng đồng địa phương và thực hành du lịch có trách nhiệm.",
    bookingTitle: "Đặt Chỗ Dễ Dàng",
    bookingText: "Quá trình đặt chỗ trực tuyến đơn giản với thanh toán linh hoạt.",
    teamTitle: "Đội Ngũ Của Chúng Tôi",
    teamSubtitle: "Gặp gỡ những người đam mê đằng sau MoroccoLovesYou",
    happyTravelers: "Du Khách Hài Lòng",
    yearsExp: "Năm Kinh Nghiệm",
    destinationsCount: "Điểm Đến",
    satisfactionRate: "Tỷ Lệ Hài Lòng"
  },
  footer: {
    description: "Khám phá sự kỳ diệu của Maroc cùng chúng tôi. Trải nghiệm những chuyến phiêu lưu khó quên.",
    quickLinks: "Liên Kết Nhanh",
    more: "Thêm",
    contactInfo: "Thông Tin Liên Hệ",
    copyright: "© 2024 MoroccoLovesYou. Đã đăng ký bản quyền."
  },
  starBanner: {
    ceoMessage: "THÔNG ĐIỆP CỦA CEO",
    watchVideo: "Xem video của tôi",
    readMessage: "& đọc thông điệp",
    getToKnow: "Làm quen với",
    ilanPersonally: "Ilan cá nhân"
  },
  tourMini: {
    days: "10 NGÀY",
    nights: "/ 9 ĐÊM",
    title: "TOUR MAROC\nCAO CẤP",
    years: "2026 - 2027",
    departures: "KHỞI HÀNH HÀNG THÁNG",
    allIncluded: "TRỌN GÓI\nFULL BOARD",
    recommendations: "Đề xuất",
    recCount: "500+ khách du lịch hạnh phúc"
  },
  cityDetail: {
    notFound: "Không tìm thấy thành phố",
    backHome: "Về Trang Chủ",
    discoverSubtitle: "Khám phá vẻ đẹp và văn hóa",
    planTrip: "Lên Kế Hoạch Chuyến Đi Đến",
    galleryOf: "Thư Viện Của",
    bookExperience: "Đặt Trải Nghiệm Này",
    requestItinerary: "Yêu Cầu Lịch Trình Chi Tiết",
    readyToVisit: "Sẵn Sàng Để Thăm",
    readyToVisitText: "Hãy để chúng tôi lập kế hoạch cho chuyến đi hoàn hảo của bạn",
    planMyTrip: "Lên Kế Hoạch",
    talkExpert: "Nói Chuyện Chuyên Gia"
  },
  transportation: {
    pageTitle: "Dịch vụ vận chuyển VIP & Tài xế",
    pageSubtitle: "Sang trọng, Thoải mái & An toàn trên khắp Ma-rốc",
    introTitle: "Dịch vụ vận chuyển & Tài xế VIP của chúng tôi",
    introP1: "Tại Morocco Loves You, vận chuyển không chỉ là di chuyển từ nơi này sang nơi khác.",
    introP2: "Đó là một phần của trải nghiệm.",
    introP3: "Chúng tôi cung cấp các phương tiện hiện đại, sạch sẽ, thoải mái và có máy lạnh hoàn toàn trên khắp Ma-rốc — với tài xế chuyên nghiệp, lòng hiếu khách nồng hậu và dịch vụ VIP ngay từ những giây phút đầu tiên.",
    introP4: "Cho dù bạn đi du lịch theo cặp đôi, gia đình, phái đoàn doanh nghiệp hay nhóm riêng, chúng tôi đảm bảo hành trình của bạn sẽ an toàn, thư giãn và khó quên.",
    servicesTitle: "Dịch vụ vận chuyển của chúng tôi bao gồm",
    servicesList: [
      "Xe buýt VIP hiện đại",
      "Xe minibus sang trọng",
      "Xe hơi riêng",
      "Xe Jeep 4x4 cho những chuyến phiêu lưu sa mạc",
      "Xe Limousine VIP",
      "Đưa đón sân bay",
      "Tài xế chuyên nghiệp đa ngôn ngữ",
      "Máy lạnh thoải mái",
      "Phương tiện sạch sẽ và ngăn nắp",
      "Tủ lạnh trên các phương tiện được chọn",
      "Hệ thống TV & giải trí",
      "Âm nhạc trong suốt hành trình",
      "Lái xe an toàn và êm ái",
      "Hỗ trợ 24/7 trên khắp Ma-rốc"
    ],
    driversTitle: "Gặp gỡ các tài xế của chúng tôi",
    driversText1: "Các tài xế của chúng tôi là một phần của gia đình Morocco Loves You.",
    driversText2: "Chuyên nghiệp, tôn trọng, giàu kinh nghiệm và luôn sẵn lòng giúp đỡ với nụ cười trên môi.",
    driversText3: "Nhiều tài xế của chúng tôi nói được nhiều ngôn ngữ và am hiểu sâu sắc về Ma-rốc — giúp khách hàng cảm thấy thoải mái, an toàn và được kết nối trong suốt hành trình.",
    safetyTitle: "An toàn & Thoải mái là trên hết",
    safetyText1: "Sự thoải mái và an toàn của bạn là ưu tiên hàng đầu của chúng tôi.",
    safetyText2: "Tất cả các phương tiện đều được bảo trì thường xuyên, vệ sinh sạch sẽ và chuẩn bị kỹ lưỡng trước mỗi chuyến đi.",
    safetyText3: "Chúng tôi chỉ làm việc với những tài xế chuyên nghiệp đáng tin cậy và các đối tác vận chuyển chất lượng cao.",
    categories: {
      buses: "Xe buýt VIP",
      minibuses: "Xe minibus sang trọng",
      cars: "Xe riêng & Chuyển vùng VIP",
      jeeps: "Xe Jeep 4x4 & Vận chuyển sa mạc",
      meetDrivers: "Gặp gỡ các tài xế của chúng tôi",
      videos: "Video trải nghiệm vận chuyển"
    },
    videoGalleryTitle: "Video trải nghiệm VIP",
    ctaTitle: "Sẵn sàng khám phá Ma-rốc một cách thoải mái?",
    ctaSubtitle: "Nói chuyện trực tiếp với Allan – CEO & Người sáng lập",
    whatsapp: "WhatsApp: +972546338757",
    moroccoLine: "Đường dây trực tiếp Ma-rốc: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "Tour Kosher Sang Trọng tại Morocco",
    pageSubtitle: "Di sản Do Thái chân thực, ẩm thực 100% kosher, dịch vụ sang trọng và những trải nghiệm Morocco độc đáo.",
    introTitle: "Trải nghiệm di sản Do Thái sang trọng",
    introHeading: "Khám phá Morocco Do Thái chân thực",
    introText: "Khám phá nguồn gốc sâu sắc của lịch sử Do Thái tại Morocco qua một hành trình tinh tế, chân thực và cao cấp. Chúng tôi tạo ra chuyến đi liền mạch cho các cộng đồng Do Thái trên toàn thế giới, tập trung vào di sản, kết nối và sự thoải mái tuyệt đối.",
    introQuote: "“Morocco là vùng đất của lòng khoan dung và chung sống, nơi di sản Do Thái được gìn giữ bằng tình yêu và sự tôn trọng.”",
    experiencesTitle: "Trải nghiệm kosher của chúng tôi bao gồm",
    experiencesList:     [
          "Ẩm thực và nhà hàng 100% kosher",
          "Có đầu bếp kosher riêng",
          "Ẩm thực Do Thái Morocco truyền thống",
          "Khách sạn sang trọng 4 & 5 sao",
          "Phương tiện VIP riêng",
          "Hướng dẫn viên chuyên nghiệp đa ngôn ngữ",
          "Tour di sản Do Thái và giáo đường"
    ],
    expFood: "Ẩm thực 100% kosher",
    expRestaurant: "Nhà hàng kosher",
    expChef: "Có đầu bếp kosher riêng",
    expCuisine: "Ẩm thực Do Thái Morocco truyền thống",
    expHotels: "Khách sạn sang trọng 4 & 5 sao",
    expDeluxeHotels: "Khách sạn deluxe theo yêu cầu",
    expTransport: "Phương tiện VIP riêng",
    expDrivers: "Tài xế chuyên nghiệp",
    expAC: "Xe có điều hòa",
    expWifi: "WiFi, TV và tủ lạnh trên một số xe",
    expGuides: "Hướng dẫn viên chuyên nghiệp đa ngôn ngữ",
    expStaff: "Nhân viên nói tiếng Hebrew / Anh / Pháp / Tây Ban Nha / Nga / Đức",
    expHeritage: "Tour di sản Do Thái",
    expSynagogues: "Giáo đường cổ",
    expCemeteries: "Nghĩa trang Do Thái",
    expMuseums: "Bảo tàng Do Thái",
    expSpiritual: "Trải nghiệm tâm linh và văn hóa",
    expDesert: "Trải nghiệm sa mạc Sahara",
    expHammam: "Trải nghiệm hammam Morocco",
    expAttractions: "Điểm tham quan độc đáo khắp Morocco",
    expAssistance: "Hỗ trợ 24/7",
    packagesTitle: "Gói du lịch kosher linh hoạt",
    packagesIntro: "Chúng tôi tùy chỉnh từng chuyến đi theo nhu cầu, truyền thống, phong cách du lịch, ngày đi và kỳ vọng của khách.",
    package4_5: "4-5 Days",
    package7_8: "7-8 Days",
    package10_11: "10-11 Days",
    package13_14: "13-14 Days",
    package21: "21 ngày",
    packageTailor: "Tour riêng theo yêu cầu",
    packagesQuote: "“Chúng tôi tùy chỉnh từng chuyến đi theo nhu cầu, truyền thống, phong cách du lịch, ngày đi và kỳ vọng của khách.”",
    safetyTitle: "Du lịch thoải mái, chuyên nghiệp và an toàn",
    safetyQuote: "“Các tour của chúng tôi được vận hành với sự chú trọng cao đến sự thoải mái, tổ chức, chất lượng dịch vụ và phối hợp chuyên nghiệp khắp Morocco.”",
    b2bTitle: "Hợp tác B2B du lịch Do Thái",
    b2bText: "Chúng tôi hợp tác với cộng đồng Do Thái, giáo đường, giáo sĩ và đơn vị tour kosher trên toàn thế giới để tạo nên những hành trình di sản ý nghĩa.",
    b2bPartnersList: "Chúng tôi làm việc với: cộng đồng Do Thái, giáo đường, giáo sĩ, tổ chức Do Thái, đơn vị tour kosher và đại lý du lịch toàn cầu.",
    partnerBtn: "Hợp tác với chúng tôi",
    galleryTitle: "Thư viện trải nghiệm kosher",
    videosTitle: "Video nổi bật",
    ctaTitle: "Sẵn sàng bắt đầu hành trình?",
    msgAllan: "Nhắn Allan trên WhatsApp",
    callMorocco: "Gọi Morocco: +212 6 63 63 05 79",
    ceoContact: "Nói chuyện trực tiếp với Allan Hatchuel trên WhatsApp",
    exploreBtn: "Khám phá tour kosher"
  },
  aria: {
    openMenu: "Mở menu",
    closeMenu: "Đóng menu",
    whatsappSocial: "WhatsApp",
    kosherTravel: "Du lịch kosher Morocco",
    logoAlt: "Logo MoroccoLovesYou",
    kingAlt: "Vua Morocco",
    kosherOptionsAlt: "Tùy chọn kosher",
    jewishHeritageArchitecture: "Kiến trúc di sản Do Thái",
    kosherMoroccanTable: "Bàn ăn Morocco kosher",
    luxuryHospitality: "Dịch vụ hiếu khách sang trọng",
    kosherExperience: "Trải nghiệm kosher",
    jewishHeritageMorocco: "Di sản Do Thái Morocco",
    kosherFoodMorocco: "Ẩm thực kosher Morocco",
    jewishHeritageExperience: "Trải nghiệm di sản Do Thái"
  }
};

export default vi;
